import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    username: '',
    nickname: '',
    avatar: '',
    shopCode: '',
    shopList: []
}

const reducers = createActions({
    getUserInfoAction: {
        success: (state, action) => {
            const { account: username, shops = [], ...other } = action.payload
	        
	        let shopCode = localStorage.getItem('shopCode')
	        if (!shopCode || shops.findIndex(shop => shop.shopId === shopCode) === -1) {
		        shopCode = shops[0]?.shopId || ''
		        localStorage.setItem('shopCode', shopCode)
	        }
	        
            const {
                roleBase: { configuration, ...otherRoleBase}
            } = shops.find(shop => shop.shopId === shopCode)
	        
            return {
                ...state,
	            ...other,
	            role: {
                    ...otherRoleBase,
		            configuration: JSON.parse(configuration)
	            },
	            username,
	            shopCode,
	            shopList: shops
            }
        }
    }
}, actions)

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    ...reducers,
    reducers: {
        changeShopCode: (state, action) => {
            const shopCode = action.payload || state.shopList[0].shopId
	        
	        localStorage.setItem('shopCode', shopCode)
	        if (state.shopList && state.shopList.length > 0) {
		        const {
			        roleBase: { configuration, ...otherRoleBase}
		        } = state.shopList.find(shop => shop.shopId === shopCode)
		        
		        return {
			        ...state,
			        shopCode,
			        role: {
				        ...otherRoleBase,
				        configuration: JSON.parse(configuration)
			        }
		        }
	        }
            
            return { ...state, shopCode }
        }
    }
})

export const {
    changeShopCode
} = userInfoSlice.actions

export const getShopItem = (state) => {
    const { shopCode, shopList } = state.userInfo
    return shopList.find(item => item.shopId === shopCode)
}

export default userInfoSlice
